var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddress(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.143,
    height: 17.922,
    viewBox: "0 0 13.143 17.922",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Registered_Address",
    "data-name": "Registered Address",
    transform: "translate(-441.778 -185.258)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M448.35,203.18a.606.606,0,0,0,.466-.227c.251-.31,6.106-7.659,6.106-11.124a6.572,6.572,0,1,0-13.143,0c0,3.465,5.855,10.813,6.106,11.124a.606.606,0,0,0,.466.227Zm0-16.728a5.385,5.385,0,0,1,5.377,5.377c0,2.318-3.537,7.384-5.377,9.786-1.84-2.4-5.377-7.468-5.377-9.786A5.385,5.385,0,0,1,448.35,186.453Z",
    fill: "#ff7200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M487.22,227.71a2.987,2.987,0,1,0-2.987,2.987A2.988,2.988,0,0,0,487.22,227.71Zm-4.779,0a1.792,1.792,0,1,1,1.792,1.792,1.79,1.79,0,0,1-1.792-1.792Z",
    transform: "translate(-35.883 -35.88)",
    fill: "#ff7200"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddress);
export default __webpack_public_path__ + "static/media/address.53b7bcce93ff1e0be5e9877f7caf9499.svg";
export { ForwardRef as ReactComponent };